import React from 'react';
import { ButtonV2 } from '@asigna/kit';
import { useReadOnlyWarning } from 'hooks';
import useAddress from 'hooks/use-address';
import { useArchiveVaultDialog, useCurrentSafe } from 'store';
import { IOwner } from 'types';

import { SettingsTab } from './components/SettingsTab';

export const SettingsPage: React.FC = () => {
  const { currentSafe } = useCurrentSafe();
  const { setArchiveVaultDialogOpen } = useArchiveVaultDialog();
  const walletAccount = useAddress();
  const readOnlyWarning = useReadOnlyWarning();

  const isArchiveVault = ((currentSafe?.owners as IOwner[]) || []).find(
    (owner) => owner.address === walletAccount
  )?.archived;

  return (
    <div className="flex w-full pr-20 sm:pr-24 pl-20 sm:pl-0 h-screen py-16">
      <div className="flex flex-col rounded-[16px] sm:bg-black-1 w-full relative p-0 sm:p-32 overflow-y-scroll">
        <div className="flex items-start justify-between mb-24">
          <h1 className="text-r24 text-white mb-20">Settings</h1>
          <ButtonV2
            color="secondary"
            message={isArchiveVault ? 'Unarchive Vault' : 'Archive Vault'}
            onClick={() => setArchiveVaultDialogOpen(currentSafe?._id || '')}
            disabled={Boolean(readOnlyWarning)}
            disableHint={readOnlyWarning}
          />
        </div>
        <SettingsTab />
      </div>
    </div>
  );
};
